<button mat-menu-item (click)="clicked.emit()" class="action-menu-item" [attr.data-testid]="testId() ? testId() + '-action-menu-item' : null">
  <ng-content select="[slot=icon]"></ng-content>
  <ng-content select="[slot=text]"></ng-content>
</button>
